import React, { useRef, useState } from 'react';
import {
    Chip,
    Popper,
    Fade,
    Paper,
    ClickAwayListener,
    MenuList,
    MenuItem,
    ListItemText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export const groupingOptions = [
    {
        name: 'company',
        label: 'Company',
    },
    {
        name: 'billing_company',
        label: 'Billing Company',
    },
];

const useStyles = makeStyles(() => ({
    popper: {
        zIndex: 1500,
    },
    root: {
        position: 'relative',
        display: 'inline-block',
    },
}));

const FilterSelect = ({ onClose, onChange, options = [] }) => (
    <Paper style={{ maxHeight: 312, overflow: 'auto' }}>
        <ClickAwayListener onClickAway={event => onClose(event.target)}>
            <MenuList>
                {options.map(option => (
                    <MenuItem
                        button
                        disableRipple
                        key={option.name}
                        onClick={event => onChange(option, event.target)}
                    >
                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}
            </MenuList>
        </ClickAwayListener>
    </Paper>
);

export const GroupByFilter = ({ onAction, value }) => {
    const classes = useStyles();
    const anchorRef = useRef(null);
    const [opened, setOpened] = useState(false);
    const [type, setType] = useState(
        groupingOptions.find(option => option.name === value)
    );

    const handleToggle = () => {
        setOpened(prevOpen => !prevOpen);
        onAction({ name: 'click' });
    };

    const handleClose = () => {
        setOpened(false);
        onAction({ name: 'close' });
    };

    const handleChangeType = typeOption => {
        setType(typeOption);
        handleClose();
        onAction({ name: 'change', payload: typeOption });
    };
    return (
        <div className={classes.root}>
            <Chip
                ref={anchorRef}
                label={`Group by: ${type.label}`}
                color="secondary"
                onClick={handleToggle}
                style={{ marginRight: 5 }}
            />
            <Popper
                anchorEl={anchorRef.current}
                open={opened}
                disablePortal
                transition
                placement="bottom-end"
                className={classes.popper}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps}>
                        <FilterSelect
                            onClose={handleClose}
                            onChange={handleChangeType}
                            options={groupingOptions}
                        />
                    </Fade>
                )}
            </Popper>
        </div>
    );
};
